import L from "leaflet";

const MAPTILER_KEY = 'T4SWDTpcKHKKNcQwfwhT';

export const loadOpentopoLayer = () => {
  const items = ['a', 'b', 'c'];
  const variant = items[Math.floor(Math.random()*items.length)];
  return L.tileLayer(`https://${variant}.tile.opentopomap.org/{z}/{x}/{y}.png`, { renderer: L.canvas() });
};

export const loadSatelliteLayer = () => {
  return L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { renderer: L.canvas() });
};

export const loadMaptilerLayer = () => {
  return L.tileLayer(`https://api.maptiler.com/maps/ch-swisstopo-lbm-vivid/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`,{
    tileSize: 512,
    zoomOffset: -1,
    minZoom: 1,
    attribution: "\u003ca href=\"https://www.maptiler.com/copyright/\" target=\"_blank\"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e",
    crossOrigin: true,
  });
};
